export default {
    products: [],

    cart: [],

    cartError: false,

    deliveryToOtherAddress: false,

    deliveryToPhoneAndEmail: false,

    buyerData: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        address: "",
        postal_code: "",
        city: ""
    },

    deliveryAddress: {
        first_name: "",
        last_name: "",
        address: "",
        postal_code: "",
        city: "",
        letter_type: "letter"
    },

    prisonerData: {
        prisoner_first_name: "",
        prisoner_last_name: "",
        prisoner_fathers_name: "",
        letter_type: "letter"
    },

    deliveryToOtherEmailAndPhone: false,

    edeliveryAddress: {
        phone: "",
        email: ""
    },

    invoiceData: {
        first_name: "",
        last_name: "",
        company_name: "",
        nip: "",
        address: "",
        postal_code: "",
        city: ""
    },

    invoiceDataErrors: {},

    edeliveryDataErrors: {},

    deliveryAdditionalInfo: "",

    paymentType: "",

    buyerDataErrors: {},

    deliveryDataErrors: {},

    prisonerDataErrors: {},

    deliveryToPrison: false,

    location: {},

    locations: [],

    order: {},

    currentOptionsStage: "customerData",

    letterOptions: {}
}